import request from '@/utils/request'

// 查询客户信息列表
export function listInfo(query) {
  return request({
    url: '/xm/info/list',
    method: 'get',
    params: query
  })
}

// 查询客户信息详细
export function getInfo(id) {
  return request({
    url: '/xm/info/' + id,
    method: 'get'
  })
}

// 查询客户信息详细
export function sqshInfo(id) {
  return request({
    url: '/xm/info/sqsh/' + id,
    method: 'get'
  })
}

export function kylistInfo(query){
  return request({
    url: '/xm/info/kylist',
    method: 'get',
    params: query
  })
}

export function shlcInfo(data){
  return request({
    url: '/xm/info/shlc',
    method: 'post',
    data: data
  })
}

// 新增客户信息
export function addInfo(data) {
  return request({
    url: '/xm/info',
    method: 'post',
    data: data
  })
}

// 修改客户信息
export function updateInfo(data) {
  return request({
    url: '/xm/info',
    method: 'put',
    data: data
  })
}

// 删除客户信息
export function delInfo(id) {
  return request({
    url: '/xm/info/' + id,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/xm/info.js